import { applicationApi } from "../../common/api";
import { Member } from "./types";

// Define a service using a base URL and expected endpoints
export const memberApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllMember: builder.query<Member[], boolean>({
      query: (param) => ({ url: `members`, method: 'GET', params: { isActive: param } }),
      providesTags: [{ type: 'Members', id: 'LIST' }],
    }),
    getMember: builder.query<Member, string>({
      query: (query) => `members/${query}`,
    }),
    createMember: builder.mutation<Member, any>({
      query: (body) => ({
        url: '/members',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'Members', id: 'LIST' }],
    }),
    deleteMember: builder.mutation<any, number>({
      query: (id) => ({
        url: `members/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Members', id: 'LIST' }],
    }),
    updateMember: builder.mutation<Member, any>({
      query: (body) => ({
        url: '/members',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [{ type: 'Members', id: 'LIST' }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllMemberQuery,
  useGetMemberQuery,
  useCreateMemberMutation,
  useDeleteMemberMutation,
  useUpdateMemberMutation,
} = memberApi;
